function getParentLocale(locale) {
  if (!locale || locale.indexOf('-') < 0) return null;

  return locale.substring(0, locale.indexOf('-'));
}

function getApplicableLocales(locale, invariantLocale) {
  return Array.from(iterator(locale, invariantLocale)).filter((a) => a != null);

  function* iterator(l, i) {
    if (!!i) {
      yield getParentLocale(i);

      yield i;
    }

    if (!!l) {
      yield getParentLocale(l);

      yield l;
    }
  }
}

export default function getLocale(
  locale,
  invariantLocale,
  generic,
  tenantSpecific
) {
  var result = { messages: {} };

  for (var l of getApplicableLocales(locale, invariantLocale)) {
    result = {
      ...{
        ...result,
        ...(generic.locales && generic.locales[l]),
        ...(tenantSpecific.locales && tenantSpecific.locales[l]),
      },
      messages: {
        ...result.messages,
        ...(generic.locales &&
          generic.locales[l] &&
          generic.locales[l].messages),
        ...(tenantSpecific.locales &&
          tenantSpecific.locales[l] &&
          tenantSpecific.locales[l].messages),
        ...(generic.messages && generic.messages[l]),
        ...(tenantSpecific.messages && tenantSpecific.messages[l]),
      },
    };
  }

  return result;
}



// WEBPACK FOOTER //
// ./src/app/services/localeFactory/index.js